import { MatSnackBarConfig } from "@angular/material/snack-bar";

export const SuccessDefaultOptions: MatSnackBarConfig = {
  panelClass: ['success-snackbar'],
  horizontalPosition: 'right',
  verticalPosition: 'top',
}